import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getUserAccess } from "../../Services/ApiCalling/User";

export const chatOpen = createAsyncThunk("chat/open", async (status) => {
  try {
    return status;
  } catch (err) {}
});
export const chatOpenType = createAsyncThunk("chat/type", async (status) => {
  try {
    return status;
  } catch (err) {}
});

export const chatData = createAsyncThunk(
  "chat/data",
  async ({ connectionId, header, fromUser, toUser, hidechat = false }) => {
    try {
      return { connectionId, header, fromUser, toUser, hidechat };
    } catch (err) {}
  },
);

const messageSlice = createSlice({
  name: "chat",
  initialState: {},
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(chatOpen.pending, (state) => {})
      .addCase(chatOpen.fulfilled, (state, action) => {
        state.chatOpen = action.payload;
      })
      .addCase(chatOpen.rejected, (state, action) => {});
    builder
      .addCase(chatOpenType.pending, (state) => {})
      .addCase(chatOpenType.fulfilled, (state, action) => {
        state.chatOpenType = action.payload;
      })
      .addCase(chatOpenType.rejected, (state, action) => {});
    builder
      .addCase(chatData.pending, (state) => {})
      .addCase(chatData.fulfilled, (state, action) => {
        state.connectionId = action.payload?.connectionId;
        state.header = action.payload?.header;
        state.fromUser = action.payload?.fromUser;
        state.toUser = action.payload?.toUser;
        state.hidechat = action.payload?.hidechat;
      })
      .addCase(chatData.rejected, (state, action) => {});
  },
});

export default messageSlice.reducer;
